import { render, staticRenderFns } from "./AppSelect.vue?vue&type=template&id=ba21a8f6&scoped=true"
import script from "./AppSelect.vue?vue&type=script&lang=js"
export * from "./AppSelect.vue?vue&type=script&lang=js"
import style0 from "./AppSelect.vue?vue&type=style&index=0&id=ba21a8f6&prod&lang=scss&scoped=true"
import style1 from "./AppSelect.vue?vue&type=style&index=1&id=ba21a8f6&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ba21a8f6",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSelect } from 'vuetify/lib/components/VSelect';
installComponents(component, {VSelect})
